import React from 'react';

const CardFooter = ({children, className}) => {
    return (
        <div className={["bg-white p-[10px] rounded-b-[0.5rem] border-t border-[#ededed] flex justify-start items-center", className].join(" ")}>
            {children}
        </div>
    );
};

export default CardFooter;